module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/mail-chimp-acc682d1c78aa46c6ebfe2419e4899d8.svg";